import { render, staticRenderFns } from "./PosReceiptPrint.vue?vue&type=template&id=1f88262e&"
import script from "./PosReceiptPrint.vue?vue&type=script&lang=js&"
export * from "./PosReceiptPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports